import script from "./testimonials.vue?vue&type=script&setup=true&lang=js"
export * from "./testimonials.vue?vue&type=script&setup=true&lang=js"

import "./testimonials.vue?vue&type=style&index=0&id=227bf680&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-227bf680"]])

export default __exports__